"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteData = SiteData;
exports.withSiteData = withSiteData;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useSiteData = _interopRequireDefault(require("../hooks/useSiteData"));

function SiteData(_ref) {
  var children = _ref.children;
  return children((0, _useSiteData["default"])());
}

function withSiteData(Comp) {
  return function componentWithSiteData(props) {
    var routeData = (0, _useSiteData["default"])();
    return _react["default"].createElement(Comp, (0, _extends2["default"])({}, props, routeData));
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2NvbXBvbmVudHMvU2l0ZURhdGEuanMiXSwibmFtZXMiOlsiU2l0ZURhdGEiLCJjaGlsZHJlbiIsIndpdGhTaXRlRGF0YSIsIkNvbXAiLCJjb21wb25lbnRXaXRoU2l0ZURhdGEiLCJwcm9wcyIsInJvdXRlRGF0YSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRU8sU0FBU0EsUUFBVCxPQUFnQztBQUFBLE1BQVpDLFFBQVksUUFBWkEsUUFBWTtBQUNyQyxTQUFPQSxRQUFRLENBQUMsOEJBQUQsQ0FBZjtBQUNEOztBQUVNLFNBQVNDLFlBQVQsQ0FBc0JDLElBQXRCLEVBQTRCO0FBQ2pDLFNBQU8sU0FBU0MscUJBQVQsQ0FBK0JDLEtBQS9CLEVBQXNDO0FBQzNDLFFBQU1DLFNBQVMsR0FBRyw4QkFBbEI7QUFDQSxXQUFPLGdDQUFDLElBQUQsZ0NBQVVELEtBQVYsRUFBcUJDLFNBQXJCLEVBQVA7QUFDRCxHQUhEO0FBSUQiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXHJcbmltcG9ydCB1c2VTaXRlRGF0YSBmcm9tICcuLi9ob29rcy91c2VTaXRlRGF0YSdcclxuXHJcbmV4cG9ydCBmdW5jdGlvbiBTaXRlRGF0YSh7IGNoaWxkcmVuIH0pIHtcclxuICByZXR1cm4gY2hpbGRyZW4odXNlU2l0ZURhdGEoKSlcclxufVxyXG5cclxuZXhwb3J0IGZ1bmN0aW9uIHdpdGhTaXRlRGF0YShDb21wKSB7XHJcbiAgcmV0dXJuIGZ1bmN0aW9uIGNvbXBvbmVudFdpdGhTaXRlRGF0YShwcm9wcykge1xyXG4gICAgY29uc3Qgcm91dGVEYXRhID0gdXNlU2l0ZURhdGEoKVxyXG4gICAgcmV0dXJuIDxDb21wIHsuLi5wcm9wc30gey4uLnJvdXRlRGF0YX0gLz5cclxuICB9XHJcbn1cclxuIl19